var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'glowy-blob',
    ("gradient-" + _vm.color),
    ("position-" + _vm.position),
    ("aspect-" + _vm.aspect),
    { 'is-wide': _vm.wide }
  ],style:(_vm.offset ? { '--translate-x': _vm.offset.x, '--translate-y': _vm.offset.y } : false)},[_c('div',{staticClass:"glowy-subject"}),_c('div',{staticClass:"glowy-ghost first"}),_c('div',{staticClass:"glowy-ghost second"})])}
var staticRenderFns = []

export { render, staticRenderFns }